module.exports = __webpack_public_path__ + "static/banner01zucchinis-ab912e4c9f0df40d6840d1ed955738eb.jpg";